import { Icon, TextWithHighlight } from '@dixa/lib-shared-habla';
import type { SearchUser } from 'lib-shared-types-api';

import { useAppSearchParams } from 'utils/url/useAppSearchParams';
import { userTypeAssets } from 'utils/user';
import { getUserDisplayName } from 'utils/user/getUserDisplayName';

import { ContactsListItem } from '../../../listItem/contactsListItem';

import styles from './contactsUser.module.scss';

interface ContactsCompanyProps {
  user: SearchUser;
  selected?: boolean;
}

export function ContactsUser({
  user,
  selected,
}: ContactsCompanyProps): JSX.Element {
  const { id, email, phone_number } = user;
  const contactOptions = [email, phone_number].filter(Boolean);
  const remainingContactOptionsLength = contactOptions.slice(1).length;
  const secondaryLabelText = contactOptions[0];
  const primaryLabelText = getUserDisplayName(user);
  // TODO (TEAMS-6149): Add new banned status once we transition to Postgres.
  // Until then hide the status icon entirely.
  const bannedIcon = false && <Icon className={styles.banIcon} name="ban" />;
  const {
    params: { q: searchTerm = '' },
  } = useAppSearchParams('/contacts/user/:id');

  return (
    <ContactsListItem
      primaryLabel={
        <div className={styles.label}>
          <span className={styles.ellipsis}>
            <TextWithHighlight text={primaryLabelText} highlight={searchTerm} />
          </span>
          {bannedIcon}
        </div>
      }
      secondaryLabel={
        secondaryLabelText &&
        primaryLabelText !== secondaryLabelText && (
          <div className={styles.label}>
            <span className={styles.ellipsis}>
              <TextWithHighlight
                text={secondaryLabelText}
                highlight={searchTerm}
              />
            </span>
            {!!remainingContactOptionsLength && (
              <span className={styles.more}>
                +{remainingContactOptionsLength} more
              </span>
            )}
          </div>
        )
      }
      avatar={{
        id: user.id,
        avatar_url: user.avatar_url,
        name: user.display_name,
        phone_number: user.phone_number,
      }}
      appLinkProps={{
        path: '/contacts/user/:id',
        params: {
          path: { id },
          search: { q: searchTerm },
        },
      }}
      selected={selected}
      {...(user.user_type === 'member' && {
        badgeText: userTypeAssets['member'].prettyName,
      })}
    />
  );
}
